export function Footer() {
  return (
    <footer className="bg-white">
      <div className="container mx-auto flex flex-col-reverse items-center justify-between gap-2 bg-white px-8 pb-4 sm:flex-row sm:items-end">
        <p className="text-sm text-gray-500">
          Copyright © 2025. All rights reserved.
        </p>
        <img
          src="/images/logos/astrazeneca-logo.svg"
          alt="AstraZeneca Logo"
          className="h-12"
        />
      </div>
    </footer>
  );
}
